const metaPropSideEffects = {
  name: () => {},
};

export function update(yDoc, updates) {
  yDoc.transact(() => {
    const meta = yDoc.getMap('meta');

    for (const [key, value] of Object.entries(updates)) {
      // Lineage key lives on assessment_doc_templates, not in CRDT meta.
      if (key === 'key') {
        continue;
      }

      if (metaPropSideEffects[key]) {
        metaPropSideEffects[key](value);
      }

      meta.set(key, value);
    }
  });
}
